import React from "react";
import { postFeedback } from "./api";
import { ReportDialogDefaultProps } from "./ReportDialogProps";

const useFeedbackController = ({
  hub,
  logger,
  friendlyProjectName
}) => {
  const [shownReportDialog, setShownReportDialog] = React.useState(false);
  const [reportDialogOptions, setReportDialogOptions] = React.useState(null);
  const showReportDialog = React.useCallback(function (options) {
    if (!options) {
      options = {};
    }

    const client = hub.getClient();

    if (!client._isEnabled()) {
      logger.error("Trying to call showReportDialog with Sentry Client is disabled");
      return;
    }

    const dsn = options.dsn || client.getDsn();

    if (!options.eventId) {
      options.eventId = hub.lastEventId();
    }

    if (!options.eventId) {
      logger.error("Missing `eventId` option in showReportDialog call");
      return;
    }

    if (!dsn) {
      logger.error("Missing `Dsn` option in showReportDialog call");
      return;
    }

    setReportDialogOptions({ ...ReportDialogDefaultProps,
      ...options,
      dsn
    });
    setShownReportDialog(true);
  }, [hub, logger, setReportDialogOptions]);
  const closeReportDialog = React.useCallback(() => {
    setShownReportDialog(false);
    reportDialogOptions.onClose && reportDialogOptions.onClose();
    setReportDialogOptions(null);
  }, [reportDialogOptions, setShownReportDialog, setReportDialogOptions]);
  const submitFeedback = React.useCallback(async values => {
    const options = hub.getClient().getOptions();
    return postFeedback({
      event_id: reportDialogOptions.eventId,
      project_id: reportDialogOptions.dsn.projectId,
      theme: reportDialogOptions.theme,
      friendly_project_name: friendlyProjectName,
      ...values
    }, options);
  }, [hub, reportDialogOptions, friendlyProjectName]);
  return [shownReportDialog, reportDialogOptions, closeReportDialog, showReportDialog, submitFeedback];
};

export default useFeedbackController;